var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserOctagonActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0802 9.08003V15.92C21.0802 17.04 20.4802 18.08 19.5102 18.65L13.5702 22.08C12.6002 22.64 11.4002 22.64 10.4202 22.08L4.48016 18.65C3.51016 18.09 2.91016 17.05 2.91016 15.92V9.08003C2.91016 7.96003 3.51016 6.91999 4.48016 6.34999L10.4202 2.92C11.3902 2.36 12.5902 2.36 13.5702 2.92L19.5102 6.34999C20.4802 6.91999 21.0802 7.95003 21.0802 9.08003Z",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 11.4998C13.2867 11.4998 14.3299 10.4566 14.3299 9.1698C14.3299 7.88298 13.2867 6.83984 11.9999 6.83984C10.7131 6.83984 9.66992 7.88298 9.66992 9.1698C9.66992 10.4566 10.7131 11.4998 11.9999 11.4998Z",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 17.1603C16 15.3603 14.21 13.9004 12 13.9004C9.79 13.9004 8 15.3603 8 17.1603",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserOctagonActive);
export default __webpack_public_path__ + "static/media/user-octagon-active.3271ac322d22333ac4b1255a21521cb4.svg";
export { ForwardRef as ReactComponent };